import { SB } from '@play-co/replicant';

export const battlePassSchema = {
  battlePass: SB.object({
    // event id
    eventId: SB.string(),
    // Pass purchased and active
    purchased: SB.boolean().default(false),
    // Timestamp of the pass purchase
    purchasedAt: SB.number(),
    // Number of levels completed during the battle pass
    progress: SB.int().default(0),
    // List of level indices of free rewards claimed in current event
    freeClaimed: SB.array(SB.number()),
    // List of level indices of premium rewards claimed in current event
    paidClaimed: SB.array(SB.number()),
  }).optional(),
};
